import { render, staticRenderFns } from "./MBTIresult.vue?vue&type=template&id=ba8ec5fe&scoped=true&"
import script from "./MBTIresult.vue?vue&type=script&lang=js&"
export * from "./MBTIresult.vue?vue&type=script&lang=js&"
import style0 from "./MBTIresult.vue?vue&type=style&index=0&id=ba8ec5fe&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba8ec5fe",
  null
  
)

export default component.exports